// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalTableBody from './internal';
function TableBody(props) {
    const baseComponentProps = useBaseComponent('TableBody');
    return React.createElement(InternalTableBody, { ...props, ...baseComponentProps });
}
applyDisplayName(TableBody, 'TableBody');
export default TableBody;
//# sourceMappingURL=index.js.map